exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ruleStats{background-color:#f8fafc;padding:30px;border-bottom:1px solid #eaecef}.statBox{background-color:#ffffff;box-shadow:0px 1px 5px rgba(0,0,0,0.1);border-radius:5px;text-align:center;border-bottom:5px solid #265390;padding:15px;position:relative}.statBox h4{margin-top:0;font-size:40px;color:#265390;font-weight:600;line-height:40px}.statBox label{font-size:15px;color:#969696}.statBox.activeRules{border-bottom:5px solid #21ab58}.statBox.activeRules h4{color:#21ab58}.statBox.successRules{border-bottom:5px solid #009682}.statBox.successRules h4{color:#009682}.statBox.failedRules{border-bottom:5px solid #ce4442}.statBox.failedRules h4{color:#ce4442}.statBox .btn-secondary-small{font-size:10px;font-weight:600;padding:2px 8px;min-width:auto;position:absolute;right:10px;top:10px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/rules-list/rule-statistics/rule-statistics.component.scss
// module id = 1375
// module chunks = 1